import PropTypes from 'prop-types';
import React, { lazy, useMemo } from 'react';
import { hasValue } from 'globalutils/fmUtils';
import { getValidationSchema } from './utils/validationHelper';

const Form = lazy(() =>
  import(`globalcomponents/UI/Form/${window.$environment?.CURRENT_LAYOUT}`)
);

const LoginForm = ({
  apiStatus,
  fetchLogin,
  fetchMicrosoftLogin,
  history,
  Styled,
  i18n,
  hasRegistration,
  innerComponent,
  newUI,
  redirectedFromFleetops,
  redirectedUrl: redirectedUrlsValue,
  webAppConfigurations,
}) => {
  const apiId = 'loginform';
  const hasLoginApiStatus = hasValue(apiStatus.status, 'api', apiId);
  const microsoftLoginApiId = 'microsoftloginform';
  const hasMicrosoftLoginApiStatus = hasValue(apiStatus.status, 'api', microsoftLoginApiId);

  const RenderComponent = useMemo(
    () => lazy(() => import(`@/${innerComponent}`)),
    [innerComponent]
  );

  const handleSubmit = ({
    fields,
    fetchLogin,
    apiId,
    history,
    redirectedFromFleetops,
    redirectedUrlsValue,
  }) => {
    fetchLogin({
      data: fields,
      apiId,
      callback: (out) => {
        if (out === 'mfaEnabled') {
          history.push('/user/mfa');
          return;
        }
        let redirectUrl = '/';
        if (window.$environment.SERVICE_PROVIDER === 'eldx') {
          redirectUrl = window.$environment.RESELLER;
        }
        if (redirectedFromFleetops) {
          const redirectionURL = new URL(redirectedFromFleetops);
          redirectionURL.searchParams.set('token', out.token);
          redirectionURL.searchParams.set('partnerId', window.$environment?.DOMAIN)
          redirectUrl = redirectionURL.toString();
        } else if (redirectedUrlsValue) {
          redirectUrl = redirectedUrlsValue;
        }
        window.location.href = redirectUrl;
      },
    });
  };


  return (
    <Styled.LoginWrapper newUI={newUI}>
      <div className="formLogin">
        <Form
          type="server"
          direction="column"
          initialValues={{
            username: '',
            password: '',
            rememberMe: false,
          }}
          RenderComponent={RenderComponent}
          handleOnSubmit={(fields) =>
            handleSubmit({
              fields,
              fetchLogin,
              apiId,
              history,
              redirectedFromFleetops,
              redirectedUrlsValue,
            })
          }
          customProps={{
            hasLoginApiStatus,
            hasMicrosoftLoginApiStatus,
            history,
            Styled,
            i18n,
            hasRegistration,
            fetchLogin,
            fetchMicrosoftLogin,
            webAppConfigurations,
          }}
          validationSchema={getValidationSchema(i18n)}
        />
      </div>
    </Styled.LoginWrapper>
  );
};

LoginForm.defaultProps = {
  hasRegistration: true,
};

LoginForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  fetchLogin: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  Styled: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  hasRegistration: PropTypes.bool,
  innerComponent: PropTypes.string.isRequired,
  newUI: PropTypes.bool,
  redirectedFromFleetops: PropTypes.string,
  redirectedUrl: PropTypes.string,
};

export default LoginForm;
